import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const Chat = () => {
    const eventTitle = process.env.REACT_APP_EVENT_TITLE || 'EventSawa';
    const eventDescription = process.env.REACT_APP_EVENT_DESCRIPTION || 'We make events sawa';
    const { eventId, recipientId } = useParams();
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        axios.get(`/api/events/${eventId}/messages/`).then((res) => setMessages(res.data));
    }, [eventId]);

    const sendMessage = () => {
        axios.post(`/api/chat/send-message/`, { recipientId, eventId, message })
            .then((res) => setMessages([...messages, res.data]));
    };

    return (
        <div>
            <Helmet>
                <title>{eventTitle}</title> {/* Set page title from environment variable */}
                <meta name="description" content={eventDescription} />
            </Helmet>
            <h2>Chat</h2>
            <div style={{ height: "300px", overflowY: "scroll", border: "1px solid #ddd", padding: "10px" }}>
                {messages.map((msg, index) => (
                    <p key={index}><strong>{msg.sender}:</strong> {msg.message}</p>
                ))}
            </div>

            <input type="text" placeholder="Type a message..." value={message} onChange={(e) => setMessage(e.target.value)} />
            <button onClick={sendMessage}>Send</button>
        </div>
    );
};

export default Chat;
